var CORE_DATA_TYPE = {
  TEXT_FIELD: 'textField',
  SELECT: 'select',
  CHECKBOX: 'checkbox',
  FREE_CREATABLE_AUTOCOMPLETE: 'freeCreatableAutocomplete',
  AUTOCOMPLETE: 'autocomplete',
  DATE: 'date',
  DATE_TIME: 'dateTime',
  TIME: 'time',
  PHONE_FIELD: 'phoneField',
  MULTI_LINE_TEXTFIELD: 'multiLineTextField',
  NUMBER_FIELD: 'numberField',
  USER: 'user',
  EMAIL_FIELD: 'emailField',
  SWITCH: 'switch'
};
var READ_ONLY_FIELDS = [CORE_DATA_TYPE.USER];

export { CORE_DATA_TYPE as C, READ_ONLY_FIELDS as R };
